module.exports = __webpack_public_path__ + "static/media/IsometricBeltSquatfemale.e24efabc.svg";